<template>
  <v-card class="mx-auto" :loading="ldg" :disabled="ldg">
    <v-card-title>
      <v-row dense>
        <v-col cols="12" md="8">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                plain
                icon
                :to="{
                  name: 'restitutions',
                }"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
            </template>
            <span v-text="'Átras'" />
          </v-tooltip>
          <span class="text-h6 ml-1" v-text="$route.meta.title" />
        </v-col>

        <v-col v-if="data" cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="info"
                @click.stop="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon> mdi-help </v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                fab
                class="ml-1"
                color="success"
                :loading="btn_xls_ldg"
                @click.prevent="toXls"
              >
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            Descargar XLSX
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                :color="data.observation ? '' : 'info'"
                @click.prevent="observationDlg"
              >
                <v-icon> mdi-comment-alert </v-icon>
              </v-btn>
            </template>
            <span v-text="'Observación'" />
          </v-tooltip>

          <v-tooltip v-if="data.active && data.paid_date == null" bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="warning"
                @click.prevent="insurancePaidDlg"
              >
                <v-icon> mdi-currency-usd </v-icon>
              </v-btn>
            </template>
            <span v-text="'Reg. pago'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text v-if="data">
      <v-row dense>
        <v-col cols="12" md="3">
          <ViewData
            label="Restitución"
            :value="data.folio"
            :class="data.active ? '' : 'red--text'"
          />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Lote" :value="data.group" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Tipo" :value="data.type" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Creación" :value="data.created_at" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Creado por" :value="data.created_by.email" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Contratante" :value="data.contractor.name" />
        </v-col>

        <v-col cols="12" md="3">
          <div v-if="data.stamp_folio">
            <span
              class="text-caption font-weight-bold"
              v-text="'Folio Fact.'"
            />
            <br />
            <span v-text="data.stamp_folio" />

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  x-small
                  class="ml-1"
                  color="cyan darken-3"
                  dark
                  :loading="btn_ldg"
                  @click.prevent="downloadFile(data.stamp_id, 'pdf')"
                >
                  <v-icon small> mdi-file-download </v-icon>
                </v-btn>
              </template>
              <span v-text="'Factura PDF'" />
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  x-small
                  class="ml-1"
                  color="teal darken-3"
                  dark
                  :loading="btn_ldg"
                  @click.prevent="downloadFile(data.stamp_id, 'xml')"
                >
                  <v-icon small> mdi-xml </v-icon>
                </v-btn>
              </template>
              <span v-text="'Factura XML'" />
            </v-tooltip>
          </div>

          <ViewData v-else label="Folio Fact." value="N/A" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Monto" :value="numberFormat(data.amount)" />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData
            label="F. pago"
            :value="data.paid_date ? data.paid_date : 'NO REG.'"
          />
        </v-col>

        <v-col cols="12" md="3">
          <ViewData label="Registros" :value="data.restitution_items.length" />
        </v-col>

        <v-col v-if="data.paid_date" cols="12" md="3">
          <ViewData
            label="F. pago"
            :value="data.paid_date ? data.paid_date : 'NO REG.'"
          />
        </v-col>

        <v-col v-if="data.paid_date" cols="12" md="3">
          <ViewData
            label="Payment ID"
            :value="data.payment_id ? data.payment_id : 'NO REG.'"
          />
        </v-col>

        <v-col v-if="data.paid_date" cols="12" md="3">
          <div
            v-if="
              data.stamp_receipt_id ||
                (!data.stamp_receipt_id && data.stamp_receipt_cancel_id)
            "
          >
            <span
              class="text-caption font-weight-bold"
              v-text="'Folio C. Pago'"
            />
            <br />
            <span v-text="data.stamp_receipt_folio" />

            <v-tooltip v-if="data.active" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  x-small
                  class="ml-1"
                  color="cyan darken-1"
                  dark
                  :loading="btn_ldg"
                  @click.prevent="downloadFile(data.stamp_receipt_id, 'pdf')"
                >
                  <v-icon small> mdi-file-download </v-icon>
                </v-btn>
              </template>
              <span v-text="'C. pago PDF'" />
            </v-tooltip>

            <v-tooltip v-if="data.active" bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  x-small
                  class="ml-1"
                  color="teal darken-1"
                  dark
                  :loading="btn_ldg"
                  @click.prevent="downloadFile(data.stamp_receipt_id, 'xml')"
                >
                  <v-icon small> mdi-xml </v-icon>
                </v-btn>
              </template>
              <span v-text="'C. pago XML'" />
            </v-tooltip>

            <div v-if="login.permissions.restitutions.delete">
              <v-btn
                x-small
                color="warning"
                dark
                :loading="btn_stamp_receipt_ldg"
                @click.prevent="regenerateStampReceipt"
              >
                Regenerar
                <v-icon right small>mdi-refresh</v-icon>
              </v-btn>
            </div>
          </div>

          <ViewData v-else label="Folio C. Pago" value="N/A" />
        </v-col>

        <v-col v-if="data.observation" cols="12">
          <ViewData label="Observación" :value="data.observation" />
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="tbl_srch"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
            dense
          />
        </v-col>

        <v-col cols="12">
          <v-data-table
            :headers="tbl_hdrs"
            :search="tbl_srch"
            :items="data.restitution_items"
            :items-per-page="15"
            dense
          >
            <template v-slot:item.index="{ item, index }">
              <b v-text="index + 1" />
            </template>

            <template v-slot:item.insured_full_name="{ item }">
              <span :class="item.insured_id ? '' : 'orange--text'">
                {{ item.insured_full_name }}
              </span>
            </template>

            <template v-slot:item.amount="{ item }">
              {{ numberFormat(item.amount) }}
            </template>

            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <v-tooltip v-if="item.type == 3" left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      icon
                      small
                      color="info"
                      @click.prevent="rsRefoundBillsDlg(item)"
                    >
                      <v-icon small> mdi-file </v-icon>
                    </v-btn>
                  </template>
                  Ver facturas
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </v-col>

        <v-col v-if="login.permissions.restitutions.delete" cols="12">
          <v-tooltip v-if="data.active && data.paid_date == null" top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                color="error"
                @click.prevent="destroy"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span v-text="'Eliminar'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog
      v-model="insurance_paid_dlg"
      scrollable
      persistent
      max-width="300px"
    >
      <v-card
        tile
        :disabled="insurance_paid_dlg_ldg"
        :loading="insurance_paid_dlg_ldg"
      >
        <v-toolbar dark dense>
          <v-toolbar-title> Pago aseguradora </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="insurance_paid_dlg = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-if="insurance_paid">
          <v-form v-on:submit.prevent ref="insurance_paid_form" lazy-validation>
            <v-row dense class="pt-5">
              <v-col cols="12">
                <DatePicker
                  label="F. Pago"
                  :model.sync="insurance_paid.paid_date"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Payment ID*"
                  v-model="insurance_paid.payment_id"
                  type="text"
                  dense
                  :rules="rules.required"
                  maxlength="20"
                  counter
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  label="Monto*"
                  v-model="insurance_paid.amount"
                  type="number"
                  dense
                  min="0"
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  dark
                  small
                  color="success"
                  @click.prevent="insurancePaidSave"
                >
                  Enviar
                  <v-icon small right> mdi-send </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="observation_dlg" scrollable persistent max-width="800px">
      <v-card
        tile
        :disabled="observation_dlg_ldg"
        :loading="observation_dlg_ldg"
      >
        <v-toolbar dark dense>
          <v-toolbar-title> Actualizar </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="observation_dlg = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-form v-on:submit.prevent ref="observation_form" lazy-validation>
            <v-row dense class="pt-5">
              <v-col cols="12">
                <v-textarea
                  label="Observación"
                  rows="3"
                  v-model="observation"
                  dense
                  :rules="rules.required"
                />
              </v-col>

              <v-col cols="12">
                <v-btn
                  block
                  dark
                  small
                  color="info"
                  @click.prevent="observationSave"
                >
                  Continuar
                  <v-icon small right> mdi-send </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="rs_refound_bills_dlg"
      scrollable
      persistent
      max-width="700"
    >
      <v-card
        tile
        :disabled="rs_refound_bills_ldg"
        :loading="rs_refound_bills_ldg"
      >
        <v-toolbar dark dense>
          <v-toolbar-title> FACTURAS </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn icon dark @click="rs_refound_bills_dlg = false">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="pt-3">
          <v-row class="pt-3">
            <v-col cols="12">
              <v-simple-table dense>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th width="20px" v-text="'#'" />
                      <th class="text-center" v-text="'Folio'" />
                      <th class="text-center" v-text="'PDF'" />
                      <th class="text-center" v-text="'XML'" />
                    </tr>
                  </thead>

                  <tbody v-if="rs_refound_bills.length > 0">
                    <tr
                      v-for="(rs_refound_bill, i) in rs_refound_bills"
                      :key="i"
                    >
                      <td class="font-weight-bold" v-text="i + 1" />
                      <td
                        class="text-center"
                        v-text="rs_refound_bill.xml_folio"
                      />

                      <td class="text-center">
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              small
                              color="error"
                              @click.prevent="dwnDoc(rs_refound_bill.doc_pdf)"
                            >
                              <v-icon small> mdi-file </v-icon>
                            </v-btn>
                          </template>
                          Descargar
                        </v-tooltip>
                      </td>

                      <td class="text-center">
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              icon
                              small
                              color="info"
                              @click.prevent="dwnDoc(rs_refound_bill.doc_xml)"
                            >
                              <v-icon small> mdi-xml </v-icon>
                            </v-btn>
                          </template>
                          Descargar
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  msgAlert,
  base64ToArrayBuffer,
  dateTimeToFile,
  dateTimeNow,
  rules,
  msgConfirm,
} from "../../control";
import FaqDlg from "../../components/FaqDlg.vue";
import ViewData from "../../components/ViewData.vue";
import DatePicker from "../../components/DatePicker.vue";

export default {
  components: {
    FaqDlg,
    ViewData,
    DatePicker,
  },

  data() {
    return {
      id: this.$attrs.id,
      login: this.$store.getters.getLogin,
      rules: rules(),
      ldg: false,
      data: null,
      tbl_srch: "",
      tbl_hdrs: [
        {
          text: "#",
          value: "index",
          sortable: false,
          filterable: false,
          width: "45",
        },
        {
          text: "Folio",
          value: "folio",
        },
        {
          text: "ID SM",
          value: "insured_enrollment",
        },
        {
          text: "Asegurado",
          value: "insured_full_name",
        },
        {
          text: "Proveedor | Médico",
          value: "provider_name",
        },
        {
          text: "Deducible",
          value: "deducible_amount",
        },
        {
          text: "Coaseguro %",
          value: "coinsurance_percent",
        },
        {
          text: "A. F. recepción",
          value: "insurance_reception_date",
        },
        {
          text: "Monto",
          value: "amount",
        },
        {
          text: "",
          value: "action",
          sortable: false,
          filterable: false,
          width: "60",
        },
      ],
      btn_ldg: false,
      btn_xls_ldg: false,
      btn_stamp_receipt_ldg: false,
      insurance_paid: null,
      insurance_paid_dlg: false,
      insurance_paid_dlg_ldg: false,
      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,
      observation: null,
      observation_dlg: false,
      observation_dlg_ldg: false,
      rs_refound_bills: null,
      rs_refound_bills_dlg: false,
      rs_refound_bills_ldg: false,
    };
  },

  methods: {
    numberFormat(v) {
      return Number(parseFloat(v).toFixed(2)).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },

    getData() {
      this.ldg = true;

      Axios.get(
        URL_API + "/restitutions/" + this.id,
        headersToken(this.login.token),
      )
        .then((res) => {
          this.data = res.data.data;
        })
        .finally(() => {
          this.ldg = false;
        });
    },

    downloadFile(stamp_id, ext) {
      this.btn_ldg = true;

      Axios.get(
        URL_API +
          "/bills/stamped/" +
          stamp_id +
          "/files/" +
          ext +
          "/" +
          (this.data.is_rha ? "1" : "2"),
        headersToken(this.login.token),
      )
        .then((res) => {
          this.$swal.fire(
            msgAlert(res.data.success ? "success" : "error", res.data.message),
          );

          if (res.data.success) {
            const blob = new Blob([base64ToArrayBuffer(res.data.data)], {
              type: "application/" + ext,
            });

            let downloadLink = document.createElement("a");
            downloadLink.setAttribute("target", "_blank");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download =
              "SM_bill" + stamp_id + "_" + dateTimeToFile() + "." + ext;
            downloadLink.click();
          } else {
            console.log(res.data.message);
          }
        })
        .finally(() => {
          this.btn_ldg = false;
        });
    },

    insurancePaidDlg() {
      this.insurance_paid = {
        id: this.data.id,
        paid_date: dateTimeNow().substring(0, 10),
        payment_id: "",
        amount: this.data.amount,
      };
      this.insurance_paid_dlg_ldg = false;
      this.insurance_paid_dlg = true;
    },

    insurancePaidSave() {
      if (this.$refs.insurance_paid_form.validate()) {
        const diff = this.insurance_paid.amount != this.data.amount;

        if (!diff) {
          this.insurancePaidHandle();
        } else {
          this.$swal
            .fire(
              msgConfirm(
                "El monto es diferente al registrado (" +
                  this.numberFormat(this.data.amount) +
                  "), ¿Continuar con el envio?",
              ),
            )
            .then((res) => {
              if (res.isConfirmed) {
                this.insurancePaidHandle();
              }
            });
        }
      } else {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );
      }
    },

    insurancePaidHandle() {
      this.$swal
        .fire(msgConfirm("¿Confirma enviar la información?"))
        .then((res) => {
          if (res.isConfirmed) {
            this.insurance_paid_dlg_ldg = true;

            Axios.post(
              URL_API + "/restitutions/insurance/paid",
              this.insurance_paid,
              headersToken(this.login.token),
            )
              .then((res) => {
                this.$swal.fire(
                  msgAlert(
                    res.data.success ? "success" : "error",
                    res.data.message,
                  ),
                );

                if (res.data.success) {
                  this.insurance_paid_dlg = false;
                  this.getData();
                } else {
                  console.log(res.data.message);
                }
              })
              .finally(() => {
                this.insurance_paid_dlg_ldg = false;
              });
          }
        });
    },

    destroy() {
      this.$swal
        .fire(msgConfirm("¿Confirma elminiar registro?"))
        .then((res) => {
          if (res.isConfirmed) {
            this.ldg = true;

            Axios.delete(
              URL_API + "/restitutions/" + this.id,
              headersToken(this.login.token),
            )
              .then((res) => {
                this.$swal.fire(
                  msgAlert(
                    res.data.success ? "success" : "error",
                    res.data.message,
                  ),
                );

                if (res.data.success) {
                  this.$router.push({ name: "restitutions" });
                }
              })
              .finally(() => {
                this.ldg = false;
              });
          }
        });
    },

    observationDlg() {
      this.observation = this.data.observation ? this.data.observation : "";
      this.observation_dlg_ldg = false;
      this.observation_dlg = true;
    },

    observationSave() {
      if (this.$refs.observation_form.validate()) {
        this.$swal
          .fire(msgConfirm("¿Confirma actualizar la observación?"))
          .then((rsp) => {
            if (rsp.isConfirmed) {
              this.observation_dlg_ldg = true;

              Axios.post(
                URL_API + "/restitutions/observation",
                {
                  id: this.data.id,
                  observation: this.observation,
                },
                headersToken(this.login.token),
              )
                .then((rsp) => {
                  this.$swal.fire(
                    msgAlert(
                      rsp.data.success ? "success" : "error",
                      rsp.data.message,
                    ),
                  );

                  if (rsp.data.success) {
                    this.observation_dlg = false;
                    this.getData();
                  }
                })
                .finally(() => {
                  this.observation_dlg_ldg = false;
                });
            }
          });
      } else {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );
      }
    },

    rsRefoundBillsDlg(item) {
      this.rs_refound_bills = [];
      this.rs_refound_bills_ldg = true;
      this.rs_refound_bills_dlg = true;

      Axios.get(
        URL_API + "/rss/" + item.rs_id + "/rs_refound_bills",
        headersToken(this.login.token),
      )
        .then((res) => {
          this.rs_refound_bills = res.data.data;
        })
        .finally(() => {
          this.rs_refound_bills_ldg = false;
        });
    },

    dwnDoc(doc) {
      const blob = new Blob([base64ToArrayBuffer(doc.cnt)], {
        type: "application/" + doc.ext,
      });

      let downloadLink = document.createElement("a");
      downloadLink.setAttribute("target", "_blank");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = dateTimeToFile() + "." + doc.ext;
      downloadLink.click();
    },

    toXls() {
      this.btn_xls_ldg = true;

      Axios.post(
        URL_API + "/restitutions/" + this.id + "/toxlsx",
        {
          data: this.data,
        },
        headersToken(this.login.token),
      )
        .then((rsp) => {
          if (rsp.data.success) {
            const blob = new Blob([base64ToArrayBuffer(rsp.data.data)], {
              type: "application/xlsx",
            });

            let downloadLink = document.createElement("a");
            downloadLink.setAttribute("target", "_blank");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download =
              "SM_RES_" + this.data.folio + "_" + dateTimeToFile() + ".xlsx";
            downloadLink.click();
          } else {
            this.$swal.fire(msgAlert("error", "Error al generar archixo XLSX"));
          }
        })
        .finally(() => {
          this.btn_xls_ldg = false;
        });
    },

    regenerateStampReceipt() {
      this.$swal
        .fire(
          msgConfirm(
            "¿Confirma regenerar el complemento de pago? El complemento actual será cancelado y se generará uno nuevo.",
          ),
        )
        .then((rsp) => {
          if (!rsp.isConfirmed) {
            return;
          }

          this.ldg = true;
          this.btn_stamp_receipt_ldg = true;

          Axios.post(
            URL_API + "/restitutions/stamp_receipt/regenerate",
            {
              id: this.data.id,
            },
            headersToken(this.login.token),
          )
            .then((rsp) => {
              this.$swal.fire(
                msgAlert(
                  rsp.data.success ? "success" : "error",
                  rsp.data.message,
                ),
              );

              if (rsp.data.success) {
                this.getData();
              } else {
                console.log(rsp.data);
              }
            })
            .catch((err) => {
              this.$swal.fire(
                msgAlert(
                  "error",
                  err.response && err.response.data && err.response.data.message
                    ? err.response.data.message
                    : "No fue posible regenerar el complemento de pago.",
                ),
              );
            })
            .finally(() => {
              this.ldg = false;
              this.btn_stamp_receipt_ldg = false;
            });
        });
    },
  },

  mounted() {
    Axios.get(
      URL_API + "/faqs/faq_interfaces/" + this.$route.meta.title,
      headersToken(this.login.token),
    ).then((res) => {
      this.faqs = res.data.data;
      this.faqs_ldg = false;
    });

    this.getData();
  },
};
</script>
